import { GroupDoc } from '../../../types/api/changes'
import { Model } from '../../../types/model'
import { ILoading } from './GroupPopup'

import PopupSectionRow from '../../../components/popup/PopupSectionRow'
import ConfirmationDialog from '../../../components/dialogs/ConfirmationDialog'
import { useState } from 'react'
import Logger from '../../../services/Logger'
import { useConnection } from 'components/providers/ConnectionProvider'
import { t } from 'i18next'
import { exitFromGroup, isConvertedGroup } from 'utils/groups'
import Button from 'components/buttons/Button'
import { APP_COLOR } from 'utils/colors'

interface ExitGroupProps extends ILoading {
  group: Model<GroupDoc>
  rowTitle?: string
  dialogTitle?: string
  dialogBodyTitle?: string
  action?: () => void
  positiveTitle?: string
}

export function ExitGroupButton(props: ExitGroupProps) {
  const connection = useConnection()
  const [openExitGroup, setOpenExitGroup] = useState(false)
  const handleOpenExitGroup = () => setOpenExitGroup(true)
  const handleCloseExitGroup = () => setOpenExitGroup(false)

  const onOkClick = async () => {
    handleCloseExitGroup()

    if (props.action) {
      props.action()
    } else {
      if (connection.isConnectionAvailable()) {
        props.setLoading(true)
        try {
          await exitFromGroup(props.group)
        } catch (e) {
          Logger.red(String(e))
        }
        props.setLoading(false)
      }
    }
  }

  const isConverted = isConvertedGroup(props.group)

  return (
    <div>
      <PopupSectionRow
        action={() => {
          handleOpenExitGroup()
        }}
        explanation={t('leaveCalendarDesc')}
        value={
          <Button size="xs">
            <div style={{ color: 'red' }}>
              {t(isConverted ? 'unlink' : 'exit')}
            </div>
          </Button>
        }
        title={props.rowTitle ?? t('exitCalendar')}
      />
      {openExitGroup && (
        <ConfirmationDialog
          leftButtonColor="grey"
          rightButtonColor={APP_COLOR}
          open={openExitGroup}
          title={props.dialogTitle ?? t('areYouSure')}
          content={props.dialogBodyTitle ?? t('leaveCalendarDesc')}
          leftButton={`${t('cancel')}`}
          rightButton={props.positiveTitle ?? `${t('leave')}`}
          handleLeftButton={() => {
            handleCloseExitGroup()
          }}
          handleRightButton={onOkClick}
          handleClose={() => {
            handleCloseExitGroup()
          }}
        />
      )}
    </div>
  )
}
